<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">客户名称</div>
                <el-autocomplete class="search-item" v-model="searchData.Name" :fetch-suggestions="querySearch" placeholder="请输入客户名称" size="small"></el-autocomplete>
                <div class="search-name">客户标签</div>
                <el-select class="search-item" size="small" filterable clearable v-model="searchData.Tags" @visible-change="tagVisibleChange($event)" style="width: 120px">
                    <el-option v-for="optionItem in tagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                </el-select>
                <div class="search-name">跟进类型</div>
                <el-autocomplete
                    size="small"
                    clearable
                    popper-class="autocomplete"
                    v-model.trim="searchData.FolloweType"
                    :fetch-suggestions="searchFolloweType"
                    @select="selectType"
                    value-key="Name"
                    style="width: 120px"
                    placeholder="请选择"
                >
                    <template slot-scope="{ item }">
                        <span :title="item.Name">{{ item.Name }}</span>
                    </template>
                </el-autocomplete>
                <div class="search-name">跟进人</div>
                <el-select v-model="searchData.FollowerId" size="small" class="search-item" filterable placeholder="请选择" clearable style="width: 120px">
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%">
                <el-table-column width="200px" prop="Name" label="客户名称" show-overflow-tooltip></el-table-column>
                <el-table-column width="120px" prop="Tags" label="客户标签" show-overflow-tooltip></el-table-column>
                <el-table-column width="100px" prop="FolloweType" label="跟进类型" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="150px" prop="FollowContent" label="跟进内容" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="150px" prop="FollowResult" label="跟进结果" show-overflow-tooltip></el-table-column>
                <el-table-column width="100px" prop="Follower" label="跟进人" show-overflow-tooltip></el-table-column>
                <el-table-column width="140px" prop="CreateTimeStr" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="Reserved" label="是否预约" show-overflow-tooltip></el-table-column>
                <el-table-column width="140px" prop="ReservationTime" label="下次跟进时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建日期" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        timePicker
        // elTableColumn
    },
    data() {
        return {
            timeVisible: false,
            SIdList: [],
            EntpCusId: '',
            EntpCusName: '',
            tagsList: [],
            followsTypeList: [],
            searchData: {
                Name: '',
                FolloweTypeId: '',
                FollowerId: '',
                StartDate: '',
                EndDate: '',
                Tags: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.getFollowsTypeList();
        this.getSIdList();
    },
    methods: {
        searchTags() {
            let url = '/api/EntpCustomers/GetEnterpriseCustomerTagList';
            this.loading = true;
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    this.tagsList = res.data;
                });
        },
        resetSearch() {
            this.searchData = {
                Name: '',
                FolloweTypeId: '',
                FollowerId: '',
                StartDate: '',
                EndDate: '',
                Tags: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetFollowsRecordsHistoriesList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        //当客户标签下拉框出现时触发
        tagVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.tagsList.length == 0) that.searchTags();
            }
        },
        querySearch(queryString, cb) {
            this.$util.searchCustomer(queryString).then(data => {
                let customerList = [];
                for (let i in data) {
                    customerList.push({
                        value: data[i].EntpCusName
                    });
                }
                cb(customerList);
            });
        },
        //跟进类型
        getFollowsTypeList() {
            let url = '/api/EntpCustomers/GetFollowsTypeList';
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        this.followsTypeList = res.data;
                    }
                })
                .catch(() => {});
        },
        searchFolloweType(queryString, cb) {
            this.searchData.FolloweTypeId = '';
            if (queryString && queryString.length > 50) {
                queryString = queryString.substring(0, 50);
                this.searchData.FolloweType = queryString;
            }
            let list = this.followsTypeList;
            this.querySearchAsync(list, queryString, cb);
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Name);
                }
            };
        },
        selectType(item) {
            this.searchData.FolloweTypeId = item.Id;
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        }
    }
};
</script>
